module.exports = __webpack_public_path__ + "45bfc82030d15614910e93035be3e9e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/regisseurinnen.jpg
// module id = 307
// module chunks = 0